import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import type { Graph, Product } from 'schema-dts'
import type { EventDescription } from '~/composables/types/event'

const useProductSchema = (
  events: EventDescription[],
  isGiftcard: boolean = true
): any => {
  const schema = ref<Graph | undefined>(undefined)
  const script = computed(() => ({
    type: 'application/ld+json',
    innerHTML: schema.value,
  }))
  const fullLocalizedUrl = useFullLocalizedUrl()

  const createSchema = (): Product[] => {
    return events.map((event) => {
      dayjs.extend(utc)
      dayjs.extend(timezone)

      const oneMonthFromNow = dayjs()
        .tz('Europe/Berlin')
        .add(1, 'month')
        .startOf('day')
        .toISOString()

      const obj = {
        '@type': 'Product',
        name: eventGetters.getTitle(event),
        url: fullLocalizedUrl(
          `/${isGiftcard ? 'giftcard' : 'k'}/${eventGetters.getPermalink(event)}/`
        ),
        image: eventGetters.getGallery(event).map((x) => x.cropped),
        description: eventGetters.getSubtitle(event),
        offers: {
          '@type': 'Offer',
          availability: 'InStock',
          price: Number(eventGetters.getMinimumPriceAmount(event)) / 100,
          url: fullLocalizedUrl(
            `/${isGiftcard ? 'giftcard' : 'k'}/${eventGetters.getPermalink(event)}/`
          ),
          priceCurrency: eventGetters.getMinimumPriceCurrency(event),
          priceValidUntil: oneMonthFromNow,
        },
        brand: {
          '@type': 'Brand',
          name: isGiftcard
            ? 'konfetti GmbH'
            : supplierGetters.getName(eventGetters.getSupplier(event)) ||
              event?.supplier,
          url: isGiftcard
            ? fullLocalizedUrl('/')
            : fullLocalizedUrl(
                supplierGetters.getKonfettiProfilePath(
                  eventGetters.getSupplier(event)
                )
              ),
        },
      }

      return obj
    })
  }

  schema.value = { '@context': 'https://schema.org', '@graph': createSchema() }

  return {
    schema,
    script,
  }
}

export default useProductSchema
